import { render, staticRenderFns } from "./AddCourseVideo.vue?vue&type=template&id=2e86144a&scoped=true"
import script from "./AddCourseVideo.vue?vue&type=script&lang=js"
export * from "./AddCourseVideo.vue?vue&type=script&lang=js"
import style0 from "./AddCourseVideo.vue?vue&type=style&index=0&id=2e86144a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86144a",
  null
  
)

export default component.exports